import { create } from "zustand";
import { LessonAction, LessonState } from "@/harness/harness.types";

interface LessonStoreState {
  state: LessonState;
  actions: LessonAction[];
  cursor: number;
  mistakes: string[];
  setState: (s: LessonState) => void;
  setActions: (a: LessonAction[]) => void;
  addMistake: (topic: string) => void;
  reset: () => void;
}

export const useLessonStore = create<LessonStoreState>((set) => ({
  state: "idle",
  actions: [],
  cursor: 0,
  mistakes: [],
  setState: (state) => set({ state }),
  setActions: (actions) => set({ actions, cursor: 0 }),
  addMistake: (topic) => set((s) => ({ mistakes: [...s.mistakes, topic] })),
  reset: () => set({ state: "idle", actions: [], cursor: 0, mistakes: [] }),
}));
